import { ILogger, logType } from './logger.service';

export class ConsoleLoggerService implements ILogger {
  log: logType;

  info: logType;

  warn: logType;

  error: logType;

  debug: logType;

  constructor() {
    this.info = this._bindLogger('log');
    this.info = this._bindLogger('info');
    this.warn = this._bindLogger('warn');
    this.error = this._bindLogger('error');
    this.debug = this._bindLogger('debug');
  }

  private _bindLogger(type: keyof Console): logType {
    return console[type].bind(console);
  }
}
